<template>

  <div id="about">
    <div class="content-us back">
      <img class="linea d-none d-md-block" alt="linea" src="../assets/images/aboutUs/lineaTiempo.png"/>
      <div class="section1">

        <div class="row no-gutters">
          <div class="col-sm-11 col-md-5">
            <p class="title pt-sm-3 px-3 text-space" v-html="$t('aboutUs.us.title')"></p>
            <p class="text text-space" v-html="$t('aboutUs.us.description')"></p>
          </div>
          <div class="col-2">
            <img class="fireCircle" alt="fire" title="fire" src="../assets/images/aboutUs/apokOld.svg"/>
          </div>
          <div class="col-11 col-md-4 py-5">
            <p class="text px-5 descrip" v-html="$t('aboutUs.us.time1')"></p>
            <img class="d-none d-sm-block imageAligh" alt="grupo ilu" title="grupo ilu" src="../assets/images/aboutUs/logoIlu.png"/>
          </div>
        </div>
      </div>

      <div class="py-3 px-5 barraClara">
        <div class="row no-gutters">
          <div class="col-sm-11 col-md-5">
            <img src="../assets/images/aboutUs/apokLogoViejo.png" alt="old apok" title="old apok" class="d-none d-sm-block imageAligh"/>
          </div>

          <div class="col-2">
          </div>

          <div class="col-11 col-md-4 pt-5">
            <div class="px-5">
              <p class="text textBar">
                {{'aboutUs.us.barraDescription' | translate}}
              </p>
              <div class="d-flex flex-row justify-content-left">
                <p class="difference-title">
                  {{ 'aboutUs.us.section2.title' | translate}} <span class="difference"> {{ 'aboutUs.us.subtitulo' | translate}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <b-row class="no-gutters">
          <b-col class="col-sm-11 col-md-5">
            <p class="text text-space" v-html="$t('aboutUs.us.section2.text1')"></p>
            <p class="text text-space" v-html="$t('aboutUs.us.section2.text2')"></p>
          </b-col>
          <b-col class="col-2 d-none d-sm-block">
            <img class="fireCircle" alt="flame" title="flame" src="../assets/images/aboutUs/flame.svg"/>
          </b-col>
          <b-col class="d-flex justify-content-center col-12 col-md-4">
            <img class="aveImage" alt="mutuk" title="mutuk" src="../assets/images/aboutUs/aveApok.png"/>
          </b-col>
        </b-row>
      </div>


      <div class="py-3">
        <b-row class="mx-0">
          <b-col class="py-5 barraOscura px-5">
            <b-row class="no-gutters">
              <b-col cols="10" offset="1" >
                <p class="image pr-md-5 text-center text-sm-left" v-html="$t('aboutUs.us.barraOscura.text1')"></p>
                <p class="text footerQuote pr-4" v-html="$t('aboutUs.us.barraOscura.frase')"></p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <div>
        <b-row class="no-gutters">
          <b-col class="col-sm-11 col-md-5 ">
            <div class="pt-5 px-5">
              <img src="../assets/images/aboutUs/apokPasionIdeas.png" :title="$t('general.slogan')" :alt="$t('general.slogan')"/>
            </div>
            <p class="text pt-sm-2 px-5 pb-3" v-html="$t('aboutUs.us.difference.text')"></p>
          </b-col>
          <b-col class="col-2 d-none d-sm-block">
            <img class="fireCircle" alt="feather" title="feather" src="../assets/images/aboutUs/apokFeather.svg"/>
          </b-col>

          <b-col class="col-12 d-flex p-0 mb-5 mb-md-0 text-center align-items-center justify-content-center col-md-5">
            <p class="difference" v-html="$t('aboutUs.us.difference.title')"></p>
          </b-col>
        </b-row>
      </div>

      <div class="px-3 pb-5 cuadroTeam d-none d-sm-block">

        <component :is="currentComponent" @showingOpen="changeRombo" :persona="item"></component>

      </div>
    </div>
  </div>

</template>

<script>
  import LayoutContent from '../components/layouts/LayoutContent'
  import team from '../config/team'
  import RomboTeam from '../components/RomboTeam'
  import RomboTeamNorte from '../components/RomboTeamNorte'
  import RomboTeamSur from '../components/RomboTeamSur'
  import RomboTeamEste from '../components/RomboTeamEste'
  import RomboTeamOeste from '../components/RomboTeamOeste'

  export default {
    name: 'AboutUs',
    data () {
      return {
        team,
        currentComponent: RomboTeam,
        item: {
          type: Object,
          default: null
        }
      }
    },
    components: {LayoutContent, RomboTeam, RomboTeamNorte, RomboTeamSur, RomboTeamEste, RomboTeamOeste},
    methods: {
      changeRombo: function (e) {
        if (e.id === 0) {
          this.item = e
          this.currentComponent = RomboTeamNorte
        }
        if (e === 'goBack') {
          this.currentComponent = RomboTeam
          this.item = null
        }
        if (e.id === 2 || e.id === 5 || e.id === 7) {
          this.item = e
          this.currentComponent = RomboTeamEste
        }
        if (e.id === 1 || e.id === 3 || e.id === 6) {
          this.item = e
          this.currentComponent = RomboTeamOeste
        }
        if (e.id === 8) {
          this.item = e
          this.currentComponent = RomboTeamSur
        }
      }
    },
    mounted () {
      this.$emit('pageShowing', 1)
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/about-us.scss';

  #about {
    height: 100%;
  }

  .imageAligh {
    margin-left: auto;
    margin-right: auto;
  }

  .row {
    margin-left: 0px;
  }

  .col-2 {
    align-self: center;
    text-align: center;
  }

  .linea {
    position: absolute;
    top: 0%;
    left: 50%;
    @media (max-width: 994px) {
      display: none !important;
    }
  }

  .section1 {
    background-color: white;
  }

  .fireCircle {
    height: 100px;
    margin-right: 5px;
    @media (max-width: 768px) {
      display: none !important;
    }
  }

  .back {
    background-color: #EFF7FB;
  }

  .text-space {
    margin: 40px;
  }

  .barraClara {
    background-color: #60BDC5;
  }

  .barraOscura {
    background-color: #005F73;
  }

  .cuadroTeam {
    background-color: #00839E;
  }

  .sectionMid {
    margin-left: 15%;
  }

  .aveImage {
    height: 250px;

    @media (min-width: 1400px) {
      height: 300px;
    }
  }

  .esloga{
    @media (max-width: 554px) {
     height: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue